module.exports = __webpack_public_path__ + "img/file-icon-link.26d5cdef.svg";